(function() {
'use strict';

angular
    .module('parking')
    .controller('ParkingResults', ParkingResults);

function ParkingResults($scope,
    parkingService,
    parkingDetailsService,
    $location,
    broker,
    tripService,
    $routeParams,
    basketService) {
    const cm = this;
    const tripId = $routeParams.tripId;

    cm.appendDetails = appendDetails;

    tripService.getTrip(tripId).then(trip => {
        const parkingRq = trip && trip.ParkingRequest;

        if (parkingRq) {
            parkingService.getSearchResults(tripId)
                .then(data => {
                        cm.parkingQuotes = data;
                        broker.publish('unblock');
                        $scope.$emit('unblock');
                    },
                    () => $location.path('parking'))
                .then(() => tripService.getParkingRequestSummary(tripId))
                .then(summary => cm.summary = summary);

            cm.selectParking = function(parking) {
                basketService.selectParking(
                    parking.QuoteId, parkingRq.AvailabilitySearchId, trip.BasketId, tripId
                );
                cm.selectedParking = parking.QuoteId;
            };
        }
    });

    function appendDetails(quote) {
        tripService.getTrip(tripId).then(trip => parkingDetailsService.appendDetails(quote, angular.copy(trip)));
    }
}
})();
